import {Pipe, PipeTransform} from '@angular/core';
import {DateUtils} from "../utils/date-utils";

@Pipe({
  name: 'localMoment',
  standalone: true
})
export class LocalMomentPipe implements PipeTransform {
  transform(value: string | Date, format: string = 'LLL'): string {
    if (!value)
      return '--';
    return DateUtils.formatDate(value, format);
  }
}
